import { render } from "./TrilhaInfoCard.vue?vue&type=template&id=7185c3a2&scoped=true"
import script from "./TrilhaInfoCard.vue?vue&type=script&lang=js"
export * from "./TrilhaInfoCard.vue?vue&type=script&lang=js"

import "./TrilhaInfoCard.vue?vue&type=style&index=0&id=7185c3a2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7185c3a2"]])

export default __exports__
import QRating from 'quasar/src/components/rating/QRating.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRating,QTooltip,QBtn,QIcon,QMenu,QList,QItem,QItemSection,QImg,QDialog,QCard,QCardSection,QSeparator,QCardActions,QInnerLoading});qInstall(script, 'directives', {ClosePopup});
